import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the IncomeExpensesListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-dish-bi',
  templateUrl: 'dish-bi.html',
})
export class DishBiPage {
  @Input() bi;

  constructor(public translate: TranslateService) {
  }

}



// WEBPACK FOOTER //
// ./src/components/bi/dish-bi/dish-bi.ts